import { makeStyles } from "../../../lib/mui-imports";
import { Styles } from "../elements";

/**
 *
 * @param {Mixed} elementsUsed null or [Menu, Button, ...]
 * @param {Object} params { palette }
 * @returns makeStyles result
 */
function useElementStyles(elementsUsed, params) {
    const allStyles = !elementsUsed;

    let keyframes = {};
    let globalStyles = {};
    let elements = {};

    // Used elements to styles: Header -> HeaderStyle
    const usedStyles = !allStyles && used2styles(elementsUsed);
    // Key: HeaderStyle
    for (const Key in Styles) {
        if (allStyles || usedStyles.includes(Key)) {
            const _classes = Styles[Key](params);

            for (const _className in _classes) {
                const isKeyframe = _className.indexOf("@keyframes ") === 0;
                const isGlobal = _className.indexOf("@global") === 0;

                if (isKeyframe) {
                    keyframes[_className] = _classes[_className];
                    delete _classes[_className];
                }

                if (isGlobal) {
                    globalStyles = { ...globalStyles, ..._classes[_className] };
                    delete _classes[_className];
                }
            }

            elements = { ...elements, ..._classes };
        }
    }

    return {
        classes: makeStyles({ ...keyframes, elements }, { name: "ElementStyles" })(),
        globalStyles,
    };
}

function used2styles(elementsUsed) {
    return elementsUsed.map(v => `${v}Styles`);
}

export default useElementStyles;
